const TripsOld = {
  getTripsOld: () => `/Trips/TripsSoldCanceled`,
  putTripData: () => `/Trips/DataBuyerPassengers`,
};

export default TripsOld;
